import { render, staticRenderFns } from "./AwardSetting.vue?vue&type=template&id=554d8c9d&scoped=true&"
import script from "./AwardSetting.vue?vue&type=script&lang=js&"
export * from "./AwardSetting.vue?vue&type=script&lang=js&"
import style0 from "./AwardSetting.vue?vue&type=style&index=0&id=554d8c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d8c9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554d8c9d')) {
      api.createRecord('554d8c9d', component.options)
    } else {
      api.reload('554d8c9d', component.options)
    }
    module.hot.accept("./AwardSetting.vue?vue&type=template&id=554d8c9d&scoped=true&", function () {
      api.rerender('554d8c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/AwardSetting.vue"
export default component.exports